import { morpherBridgeAbi, morpherMigrationAbi, morpherOracleAbi, morpherStakingABI, morpherTokenAbi } from '@/contracts/abis'
import type { TAddress, TBlockchainInfo, TChainDetails } from '@/types/graphql-global-types'
import { createPublicClient, createWalletClient, custom, defineChain, http, keccak256, toHex, getContract as getViemContract, type WalletClient, erc20Abi, } from 'viem'

export const soliditySha3 = (data: string) => {
  const return_data = keccak256(toHex(data))
  return return_data
}

export const getChainMain = () => {
  const chain = defineChain({
    id: Number(import.meta.env.VITE_MAINCHAIN_ID),
    name: 'ETH',
    network: 'Ethereum',
    nativeCurrency: {
      decimals: 18,
      name: 'ETH',
      symbol: 'ETH',
    },
    rpcUrls: {
      default: {
        http: [import.meta.env.VITE_MAINCHAIN_GETH_ENDPOINT],
      },
      public: {
        http: [import.meta.env.VITE_MAINCHAIN_GETH_ENDPOINT],
      },
    },
  });
  return chain
}

export const getChainDetails = (chainName: 'OLD' | 'NEW') => {
  let chainId = Number(import.meta.env['VITE_CHAIN_ID_' + chainName]  )
  // if (!chainId) {
  //   console.log('No chain details found for chain - ' + chainName)
  //   return null
  // }

  let chainDetails: TChainDetails = {
    chain_id:chainId,
    rpc:import.meta.env['VITE_RPC_' + String(chainId)] || '',
    rpc_wss:import.meta.env['VITE_RPC_WSS_' + String(chainId)] || '',
    explorer:import.meta.env['VITE_EXPLORER_' + String(chainId)] || '',
    name:import.meta.env['VITE_NAME_' + String(chainId)] || '',
    token:import.meta.env['VITE_TOKEN_' + String(chainId)] || '',
    gas_symbol:import.meta.env['VITE_GAS_SYMBOL_' + String(chainId)] || '',
    gas_name:import.meta.env['VITE_GAS_NAME_' + String(chainId)] || '',
  }

  return chainDetails

}


export const getPublicClientLocal = (chainName: 'OLD' | 'NEW') => {
  let chainDetails = getChainDetails(chainName)


  const chain = defineChain({
    id: chainDetails.chain_id,
    name: chainDetails.name,
    network: 'morpher',
    nativeCurrency: {
      decimals: 18,
      name: chainDetails.gas_name,
      symbol: chainDetails.gas_symbol,
    },
    rpcUrls: {
      default: {
        http: [chainDetails.rpc],
        //wss: [chainDetails.rpc_wss],
      },
      public: {
        http: [chainDetails.rpc],
        //wss: [chainDetails.rpc_wss],
      },
    },
  });

  const public_client = createPublicClient({
    chain: chain,
    transport: http(),
    cacheTime: 10_000,
  });


  return public_client as any

}

export const getChainWalletConnect = () => {
  let chainDetails = getChainDetails('NEW')


  const chain = defineChain({
    id: chainDetails.chain_id,
    name: chainDetails.name,
    network: 'morpher',
    nativeCurrency: {
      decimals: 18,
      name: chainDetails.gas_name,
      symbol: chainDetails.gas_symbol,
    },
    rpcUrls: {
      default: {
        http: [chainDetails.rpc],
        //wss: [chainDetails.rpc_wss],
      },
      public: {
        http: [chainDetails.rpc],
        //wss: [chainDetails.rpc_wss],
      },
    },
  });
  return chain
}


export const getChain = (blockchain_info?: TBlockchainInfo) => {
  const chain = defineChain({
    id: Number(blockchain_info?.chain_id || import.meta.env.VITE_MORPHER_WALLET_CHAIN_ID),
    name: 'Morpher',
    network: 'morpher',
    nativeCurrency: {
      decimals: 18,
      name: 'ETH',
      symbol: 'ETH',
    },
    rpcUrls: {
      default: {
        http: [blockchain_info?.rpc || import.meta.env.VITE_SIDECHAIN],
      },
      public: {
        http: [blockchain_info?.rpc || import.meta.env.VITE_SIDECHAIN],
      },
    },
  });
  return chain
}

export const walletConnectSign = (provider: any, message: string, eth_address: string): Promise<string | null> => {
  return new Promise((resolve, reject) => {
    try {

      provider.sendAsync({
        method: 'personal_sign',
        params: [message, eth_address]
      }, (error: any, response:any) => {

        if (error) {
          console.log('error signing message ', error.toString())
          return resolve(null)    
        }


        resolve(response?.result || null)

      })
    } catch(err: any) {
      console.log('error signing message ', err.toString())
      resolve(null)
    }
  });
}

export const getWalletClient = (provider: any, blockchain_info?: TBlockchainInfo) => {
  let walletClient: any
  if ((provider?.isWalletConnect || provider?.isTrust) && !blockchain_info) {
    walletClient = createWalletClient({
      chain: getChainWalletConnect(),
      transport: custom(provider),
      cacheTime: 10_000,
    });
    
    
  } else {
    walletClient = createWalletClient({
      chain: getChain(blockchain_info),
      transport: custom(provider),
      cacheTime: 10_000,
      
    });
  }
  

  return walletClient
}

export enum ESideChainTransaction {
  TRADE = 'TRADE',
  STAKE = 'STAKE',
  TOKEN = 'TOKEN',
  ENTRYPOINT = 'ENTRYPOINT',
  MIGRATION = 'MIGRATION',
  BRIDGE = 'BRIDGE',

}

const getAbi = (type: ESideChainTransaction) => {
  switch (type) {
    case ESideChainTransaction.STAKE:
      return morpherStakingABI;
    case ESideChainTransaction.TOKEN:
      return morpherTokenAbi;              
    case ESideChainTransaction.MIGRATION:
      return morpherMigrationAbi;      
    case ESideChainTransaction.BRIDGE:
      return morpherBridgeAbi;                        
    case ESideChainTransaction.TRADE:
    default:
      return morpherOracleAbi;
  }
};

export const getSideChainAddress = (type: ESideChainTransaction, blockchain_info?: TBlockchainInfo) => {
  switch (type) {
    case ESideChainTransaction.STAKE:
      if (blockchain_info?.staking) return blockchain_info.staking;
      return import.meta.env.VITE_MORPHER_STAKING_SIDECHAIN;

    case ESideChainTransaction.MIGRATION:
      if (blockchain_info?.migration) return blockchain_info?.migration;
      return import.meta.env.VITE_MORPHER_MIGRATION_SIDECHAIN;      

    case ESideChainTransaction.TOKEN:
      if (blockchain_info?.token) return blockchain_info.token;
      return import.meta.env.VITE_MORPHER_TOKEN_SIDECHAIN;
    
    case ESideChainTransaction.BRIDGE:
      if (blockchain_info?.bridge) return blockchain_info.bridge;
      return import.meta.env.VITE_MORPHER_BRIDGE_SIDECHAIN;

    case ESideChainTransaction.ENTRYPOINT:
      //if (blockchain_info?.entry_point) return blockchain_info.entry_point;
      return import.meta.env.VITE_ENTRYPOINT_ADDRESS;      
  
    case ESideChainTransaction.TRADE:
    default:
      if (blockchain_info?.oracle) return blockchain_info.oracle;
      return import.meta.env.VITE_MORPHER_ORACLE_SIDECHAIN;
  }
};


export const getPublicClient = (blockchain_info?: TBlockchainInfo) => {
  const chain = getChain(blockchain_info);
  const public_client = createPublicClient({
    chain: chain,
    transport: http(),
    cacheTime: 10_000,
  });


  return public_client as any
}

export const getTokenContract = async (blockchain_info: TBlockchainInfo | undefined, walletClient: WalletClient, address: TAddress) => {
  const chain = getChain(blockchain_info);
  const public_client = createPublicClient({
    chain: chain,
    transport: http(),
    cacheTime: 10_000,
  });

  const abi = getAbi(ESideChainTransaction.TOKEN);
  const contract = getViemContract({
    abi: abi,
    address: address as TAddress,
    client: { public: public_client, wallet: walletClient },
  });

  return { contract, public_client };
}

export const getMainchainBridge = async (walletClient: WalletClient) => {
  const chain = getChainMain();
  const public_client = createPublicClient({
    chain: chain,
    transport: http(),
    cacheTime: 10_000,
  });

  const address = import.meta.env.VITE_MORPHER_BRIDGE_MAINCHAIN;
  const abi = getAbi(ESideChainTransaction.BRIDGE);
  const contract = getViemContract({
    abi: abi,
    address: address as TAddress,
    client: { public: public_client, wallet: walletClient },
  });

  return { contract, public_client };
}


export const getOracleContract = async (
  blockchain_info: TBlockchainInfo | undefined,
  walletClient: WalletClient
) => {
  const chain = getChain(blockchain_info);
  const public_client = createPublicClient({
    chain: chain,
    transport: http(),
    cacheTime: 10_000,
  });

   

  const address = blockchain_info?.oracle ? blockchain_info.oracle : import.meta.env.VITE_MORPHER_ORACLE_SIDECHAIN;
  
  const contract:any = getViemContract({
    abi: morpherOracleAbi,
    address: address as TAddress,
    client: { public: public_client, wallet: walletClient },
  });

  


  return { contract, public_client };
};


export const getBridgeContract = async (
  blockchain_info: TBlockchainInfo | undefined,
  walletClient: WalletClient
) => {
  const chain = getChain(blockchain_info);
  const public_client = createPublicClient({
    chain: chain,
    transport: http(),
    cacheTime: 10_000,
  });

   

  const address = blockchain_info?.bridge ? blockchain_info.bridge : import.meta.env.VITE_MORPHER_BRIDGE_SIDECHAIN;
  
  const contract = getViemContract({
    abi: morpherBridgeAbi,
    address: address as TAddress,
    client: { public: public_client, wallet: walletClient },
  });



  return { contract, public_client };
};

export const getContract = async (
  type: ESideChainTransaction,
  blockchain_info: TBlockchainInfo | undefined,
  walletClient: WalletClient
) => {
  const chain = getChain(blockchain_info);
  const public_client = createPublicClient({
    chain: chain,
    transport: http(),
    cacheTime: 10_000,
  });

  const address = getSideChainAddress(type, blockchain_info);
  const abi = getAbi(type);
  const contract = getViemContract({
    abi: abi,
    address: address as TAddress,
    client: { public: public_client, wallet: walletClient },
  });

  return { contract, public_client };
};

export const getMainchainToken = async (walletClient: WalletClient) => {
  const chain = getChainMain();
  const public_client = createPublicClient({
    chain: chain,
    transport: http(),
    cacheTime: 10_000,
  });

  const address = import.meta.env.VITE_MORPHER_TOKEN_MAINCHAIN;
  const abi = getAbi(ESideChainTransaction.TOKEN);
  const contract = getViemContract({
    abi: abi,
    address: address as TAddress,
    client: { public: public_client, wallet: walletClient },
  });

  return { contract, public_client };
}

export const getERC20TokenContract = async (walletClient: WalletClient) => {

  const chain = getChainMain();
  const public_client = createPublicClient({
    chain: chain,
    transport: http(),
    cacheTime: 10_000,
  });

  const address = import.meta.env.VITE_MORPHER_TOKEN_MAINCHAIN;
  const abi = erc20Abi;
  const contract:any = getViemContract({
    abi: abi,
    address: address as TAddress,
    client: { public: public_client, wallet: walletClient },
  });

  

  return { contract, public_client };
} 


export const getUniswapContractv2 = async (walletClient: WalletClient) => {

  
} 